import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, UserContext } from '../../../../../Context/UserContext/UserContext';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { CompanyUnitSelectDialog } from './../../../../../Components';
import { DeleteLawWizard } from '../DeleteLawWizard';

const useStyles = makeStyles(() => ({
  topActionContainer: {
    marginBottom: '1rem',
    display: 'flex',
  },
}));

interface ICustomerLawListActionsProps {
  onDeleteComplete?: () => void;
}

export const CustomerLawListActions = ({ onDeleteComplete }: ICustomerLawListActionsProps) => {
  const { hasAccessToFeature, getCompanyUnitName } = useContext(UserContext);
  const canManage = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const openDeleteModal = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteComplete = () => {
    console.log('Laws deleted successfully');
    if (onDeleteComplete) {
      onDeleteComplete();
    }
  };

  if (!canManage) {
    return null;
  }

  return (
    <>
      <Grid container justify="flex-end" className={classes.topActionContainer} spacing={1} direction="row">
        <Grid item>
          <Button onClick={openDeleteModal} variant="outlined">
            <FormattedMessage id="lawportal.our-law.Delete-law" />
          </Button>
        </Grid>
      </Grid>

      <DeleteLawWizard
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onDeleteComplete={handleDeleteComplete}
      />
    </>
  );
};
